import React, { useEffect, useState } from 'react';
import { Spinner } from 'reactstrap';

interface ComponentProps {
  isLoading?: boolean;
  message?: string;
  delay?: number;
}

const FullPageLoader: React.FC<ComponentProps> = ({ isLoading = false, message = '', delay = 200 }) => {
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    let timeoutId: number;

    if (isLoading) {
      timeoutId = window.setTimeout(() => {
        setShowLoader(true);
      }, delay);
    } else {
      setShowLoader(false);
    }

    return () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [isLoading, delay]);

  if (isLoading && showLoader) {
    return (
      <div className="d-flex justify-content-center align-items-center loader-container">
        <div className="text-center">
          <Spinner color="primary" />
          {message && <p className="mt-3 text-primary message">{message}</p>}
        </div>
      </div>
    );
  }

  return <></>;
};

export default FullPageLoader;
